export const round = (num: number, decimals: number = 0) =>
  Math.round(num * 10 ** decimals) / 10 ** decimals

export function interpolateArray(arr: number[], newLength: number) {
  if (arr.length < 2 || newLength <= arr.length) {
    throw new Error(
      'Array must have at least two elements and new length must be greater.',
    )
  }

  let result = []
  let factor = (arr.length - 1) / (newLength - 1)

  for (let i = 0; i < newLength; i++) {
    let index = i * factor
    let lowerIndex = Math.floor(index)
    let upperIndex = Math.ceil(index)

    if (lowerIndex === upperIndex) {
      result.push(arr[lowerIndex])
    } else {
      let weight = index - lowerIndex
      let interpolatedValue =
        (1 - weight) * arr[lowerIndex] + weight * arr[upperIndex]
      result.push(interpolatedValue)
    }
  }

  return result
}
